import { Goal } from '@griply/types';

import { getCompletionPercentage } from './get-completion-percentage';
import { getGoalCompletion } from './get-goal-completion';

// Completed counts as fully achieved; `undefined` means no measurable target.
export const getGoalAchievedPercentage = (
  goal: Goal,
  goals: Goal[],
): number | undefined => {
  if (goal.completedAt) {
    return 100;
  }

  const completion = getGoalCompletion(goal, { goals });

  return completion.end === Infinity
    ? undefined
    : getCompletionPercentage(completion);
};
